import React from "react";
import UseContext from "hooks/useContext";
import { ArchiveIcon, Pencil } from "assets/icons";
import PerimeterIconButton from "pages/profil/perimeters/PerimeterIconButton";
import PerimeterMembersMenu from "pages/profil/perimeters/PerimeterMembersMenu";

const PerimeterRow = ({ perimeter, onEdit, onArchive, isArchiveDisabled }) => {
    const { language } = UseContext();
    const editLabel = `${language.getValue("perimeters.list.edit")} ${
        perimeter.name
    }`;
    const archiveLabel = `${language.getValue("perimeters.list.archive")} ${
        perimeter.name
    }`;

    return (
        <li className="flex items-center justify-between gap-4 border-b border-gray-100 py-3">
            <span
                className="min-w-0 truncate text-sm text-gray-900"
                title={perimeter.name}
            >
                {perimeter.name}
            </span>
            <div className="flex shrink-0 items-center gap-3">
                <PerimeterMembersMenu members={perimeter.members || []} />
                <PerimeterIconButton
                    label={editLabel}
                    onClick={() => onEdit(perimeter)}
                >
                    <Pencil wh={16} color="#111827" />
                </PerimeterIconButton>
                <PerimeterIconButton
                    label={archiveLabel}
                    disabled={isArchiveDisabled}
                    onClick={() => onArchive(perimeter)}
                >
                    <ArchiveIcon wh={16} color="#111827" />
                </PerimeterIconButton>
            </div>
        </li>
    );
};

export default PerimeterRow;
